import { defaultConfig } from "./config"
import { formatCurrency as format } from "@nosto/preact"

export const productImagePlaceholder = `data:image/png;base64,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`

/**
 * To override currency formatting settings:
 * 
 * import { configureCurrency } from "@nosto/preact"
 * configureCurrency("EUR", { locale: "de-DE", fractionDigits: 0 })
 */

export function getColorFromImage(url) {
    const parsedUrl = new URL(url);
    const path = parsedUrl.pathname.toString();
    
    // let color = '';
    // let isColor = false;
    // for(let i = path.length - 1; i > 0; i--) {
    //     if(path[i] === '_' && !isColor) {
    //         isColor = true;
    //     } else if (path[i] === '_' && isColor) {
    //         break;
    //     } else if (isColor) {
    //         color = path[i] + color;
    //     }
    // }
    // return color;

    //replaced with new rule
    // const match = path.match(/__([^_]+)_/);
    const match = path.match(/__{0,1}([^_]+)_/);
    // const match = path.match(/_+([^_\-]+)[_\-]/);
    //console.log(url, match[1]);
    return match ? match[1] : '';
}

export function formatCurrency(value, currency = defaultConfig.currency) {
    return format(value, currency)
}

export const parseInteger = (value) =>
    value && !Number.isNaN(value) ? Number.parseInt(`${value}`) : 0


export function unbindOriginalSearch(selector) {
    const elements = document.querySelectorAll(selector);
    elements.forEach(el => {
        var newElement = el.cloneNode(true);
        el.parentNode.replaceChild(newElement, el);
    })
}

export function getColorSwatches(skus, productImage) {
    // console.log('productImage', productImage)
    if(!skus || skus?.length === 0 || skus.length === 1 && skus[0].name === 'Default Title') return [];
    const preferredColor = (productImage) ? getColorFromImage(productImage) : false;
    const map = {};
    const swatches = [];

    // keep same order
    skus.sort((a, b) => {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        if (nameA < nameB) { return -1 }
        if (nameA > nameB) { return 1 }
        return 0;
    })

    skus.forEach(sku => {
        const color = sku.customFields?.find(field => field.key === 'color').value.toLowerCase()?.replaceAll('\/', '-')?.replaceAll(' ', '-');
        // console.log('color', color);
        // console.log('preferredColor', preferredColor)
        if(color && !map[color]) {
            if(preferredColor && preferredColor === color) {
                swatches.unshift(sku);
            } else {
                swatches.push(sku);
            }
            map[color] = true;
        }
    });    
    // console.log(swatches);
    return swatches;
}

export function getSrcset(src) {
    if(!src) return false;
    const sizes = ['360', '480', '640', '768', '840'];
    return sizes.map((size, index) => (
        `${src.replace('.jpg', `_${size}x.jpg`).replace('.png', `_${size}x.png`)} ${size}w`
    )).join(', ')
}

export function getImages(variant, productAltImages, productImage) {
    const color = variant.customFields?.find(field => field.key === 'color')?.value?.toLowerCase()?.replaceAll('\/', '-')?.replaceAll(' ', '-');
    if(!color || !productAltImages || productAltImages?.length < 1) return false;

    const images = {};
    images.main = (productImage) ? productImage
                : (variant?.imageUrl) ? variant.imageUrl
                : productAltImages.find(imageUrl => (
                    imageUrl.includes(`_${color}_1`) ||
                    imageUrl.includes(`_${color.toUpperCase()}_1`)
                ))

    images.alt = productAltImages.find(imageUrl => (
        images.main !== imageUrl && imageUrl.includes(`_${color}_3`) ||
        images.main !== imageUrl && imageUrl.includes(`_${color.toUpperCase()}_3`) ||
        images.main !== imageUrl && imageUrl.includes(`_${color}_2`) ||
        images.main !== imageUrl && imageUrl.includes(`_${color.toUpperCase()}_2`) ||
        images.main !== imageUrl && imageUrl.includes(`_${color}_`) ||
        images.main !== imageUrl && imageUrl.includes(`_${color.toUpperCase()}_`)
    ));
    return images;
}

export function checkProdPriceVaries (product) {
    let varies = false, min = product.price, max;

    // make sure highest price isn't first sku
    const skusCopy = product.skus;
    skusCopy.sort((a, b) => a.price - b.price);

    skusCopy.forEach(sku => {
        if(sku.price !== min) {
            if(sku.price < min) {
                min = sku.price;
            } else if(!max || sku.price > max) {
                max = sku.price;
            }
            varies = true;
        }
    })
    return { min, max, varies }
}

export function quickViewToggle(handle, attr, color) {
    if(window.nostoQuickView?.initModal) {
        window.nostoQuickView?.initModal(handle, attr, color);
    }
}

// new logic for swatches FEA-10938

export async function getColorSwatchesViaCustomField(customFieldValue, prodId){
    let query = `{
        products(limit: 100, filter:{customFields: {attribute:"custom-product_group", values:["${customFieldValue}"]}}) {
            products {
            name
            productId
            url
            imageUrl
            availability
            attributes {
                key
                value
            }
            skus {
                id
                name
                availability
                attributes{
                key
                value
                }
            }
            }
        }
    }`;

    const res = await fetch("https://api.nosto.com/v1/graphql", {
        method: "POST",
        headers: new Headers({
        "Content-Type": "application/graphql",
        Authorization:
        "Basic " +
        btoa(
        ":" +
            "HIAU4tKkB9Whi1DeGwUZhQBFZJtTSSVAisV2RArPvjTlgelOck2y6QGtuhUC8LXh"
        ),
        }),
        mode: "cors",
        body: query,
    });

    const data = await res.json();
    const fetchedArr = data?.data?.products?.products;
    
    const sortedArr = fetchedArr.sort((a, b) => {
        if (a.productId === prodId) return -1;
        if (b.productId === prodId) return 1;
        return a.productId - b.productId;
    });

    const swatches = sortedArr.filter(fetchedProduct => {
        let color = getColorFromImage(fetchedProduct?.imageUrl);
        color = color.toLowerCase();
        // console.log(color);
        // console.log(fetchedProduct?.url);
        if((fetchedProduct?.url?.includes(color) && fetchedProduct?.availability === "InStock") || (fetchedProduct?.url?.includes(color) && fetchedProduct?.availability === "OutOfStock")){
            return fetchedProduct;
        }
    })    
    
    return swatches;
} 


// export function getRelatedProduct(tags) {
//     for (let tag of tags) {
//         if (tag.startsWith("YGroup_")) return tag;
//     }
// }

export function getRelatedProduct(customfields) {
    for (let field of customfields) {
        if (field.key === "custom-related_styles") {
            // Split, remove empty entries, then return last
            return field.value
                .split(",")
                .filter(Boolean) // removes empty strings
                .pop();
        }
    }
    return null; // nothing found
}

export const categoriesToExcludeSwatches = ['350001266879','296890728639'];